import React from 'react';
import './sitemap.scss';

const Card = ({
  title,
  linkPath,
  style,
  cardClass,
  label,
  external = false,
}) => {
  /*
        render the card
        If a link value is passed, render an A tag.
        Render either the title, or each string representing the pageContent.
    */
  const aria = {};
  if (!linkPath) {
    aria['aria-label'] = label || '';
  }
  return (
    <div className={`sitemap-card ${cardClass}`} style={style}>
      {linkPath ? (
        <a
          href={linkPath}
          aria-label={`Navigate to: ${title[0]}`}
          rel={external ? 'noreferrer' : ''}
          target={external ? '_blank' : ''}
        >
          {title.map((text, index) => (
            <span key={index}>{text}</span>
          ))}
        </a>
      ) : (
        <ul {...aria}>
          {title.map((text, index) => (
            <li key={index}>
              <span>{text}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const Sitemap = ({ ...props }) => {
  const sitemapStructure = [
    {
      title: 'Overview',
      linkPath: '/sigmaxmtf/overview',
      pageContent: ['Product Detail'],
      externalLinks: [],
    },
    {
      title: 'Becoming a Participant',
      linkPath: '/sigmaxmtf/becoming-a-participant',
      pageContent: ['Relevant Documentation'],
      externalLinks: [],
    },
    {
      title: 'Participant Information',
      linkPath: '/sigmaxmtf/participant-information',
      pageContent: [
        'Participant Documents',
        'Technical Specifications',
        'Reference Data',
        'Delayed Market Data',
      ],
      externalLinks: [],
    },
    {
      title: 'News & Updates',
      linkPath: '/sigmaxmtf/news',
      pageContent: [
        'Market Alerts',
        'Securities Updates',
        'Securities Suspensions',
        'News & Updates',
      ],
      externalLinks: [],
    },
    {
      title: 'Contact Us',
      linkPath: '/sigmaxmtf/contact',
      pageContent: [],
      externalLinks: [],
    },
  ];
  const globalLinks = [
    {
      title: 'Contact Us',
      linkPath: '/sigmaxmtf/contact',
    },
    {
      title: 'Disclaimers',
      linkPath: '/sigmaxmtf/disclaimers',
    },
    {
      title: 'Terms of Use',
      linkPath: '/sigmaxmtf/terms-of-use',
    },
    {
      title: 'Privacy Policy',
      linkPath: 'https://www.goldmansachs.com/privacy-and-cookies/index.html',
      external: true,
    },
    {
      title: 'Site Map',
      linkPath: '/sigmaxmtf/sitemap',
    },
  ];

  return (
    <div id="sitemap">
      <h3>SiteMap</h3>
      <div id="site-map-container">
        {sitemapStructure.map((card, index) => {
          return (
            <div className="page-column" key={index}>
              <Card
                title={[card.title]}
                linkPath={card.linkPath}
                cardClass={
                  card.pageContent.length > 0 || card.externalLinks.length > 0
                    ? 'first'
                    : 'first last'
                }
                style={{ fontWeight: 'bold' }}
              ></Card>
              {card.pageContent && card.pageContent.length > 0 && (
                <Card
                  title={card.pageContent}
                  linkPath={null}
                  cardClass={card.externalLinks.length > 0 ? 'middle' : 'last'}
                  label={`page content for ${card.title}`}
                ></Card>
              )}
              {card.externalLinks.map((externalLinkCard, externalIndex) => (
                <Card
                  key={`external_${externalIndex}`}
                  title={[externalLinkCard.title]}
                  linkPath={externalLinkCard.linkPath}
                  cardClass={
                    externalIndex === card.externalLinks.length - 1
                      ? 'last'
                      : 'middle'
                  }
                ></Card>
              ))}
            </div>
          );
        })}
      </div>
      <h3>Global Links</h3>
      <div id="global-links-container">
        {globalLinks.map((card, index) => {
          return (
            <div className="page-column" key={index}>
              <Card
                title={[card.title]}
                linkPath={card.linkPath}
                style={{ fontWeight: 'bold' }}
                cardClass="first last"
                external={card.external ? true : false}
              ></Card>
            </div>
          );
        })}
      </div>
    </div>
  );
};
